import MenuCate from './menu-cate';

export default MenuCate;
